module.exports = __webpack_public_path__ + "img/custom-01.a43ef67e.jpg";